<template>
  <div>
    <el-container>
      <el-main>
        <div class="box">
          <el-form :inline="true" size="small">
            <el-form-item>
              <el-input v-model="queryParams.iccid" placeholder="请输入卡号" />
            </el-form-item>
            <el-form-item>

              <el-select clearable v-model="queryParams.status" placeholder="是否生效">
                <el-option :value="0" label="未生效" />
                <el-option :value="1" label="已生效" />
                <el-option :value="2" label="已失效" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select @focus="loadAgent" clearable filterable allow-create default-first-option v-model="queryParams.agentId" placeholder="请选择代理商">
                <el-option v-for="i in agents" :key="i.id" :label="i.agentName" :value="i.agentId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="queryParams.startTime" type="datetime" placeholder="选择开始时间" @change="dataSearchSt" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="queryParams.endTime" type="datetime" placeholder="选择结束时间" @change="dataSearchEd" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-form>

          <div style="">
            <el-button size="small" @click="list(1)" type="primary" plain icon="el-icon-search">搜索</el-button>
            <el-button size="small" @click="exportExcel" type="primary" plain icon="el-icon-download">导出</el-button>
          </div>
        </div>

        <div class="mytable">
          <el-table show-summary sum-text="合计" :summary-method="getSumMoney"  :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
                    :cell-style="{height:'5px,0',textAlign:'center'}"
                    :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                    border style="width: 100%;margin-top: 1%;height: 70vh">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="id" label="Id" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="iccid" label="ICCID" width="220" >
            </el-table-column>
            <el-table-column prop="ordNo" label="订单号" width="220">
            </el-table-column>
            <el-table-column prop="packetWxName" label="套餐包名称" width="300">
            </el-table-column>
            <el-table-column prop="agentId" label="代理商" width="150">
            </el-table-column>

            <el-table-column prop="profitPrice" label="返佣金额" >
            </el-table-column>

            <el-table-column prop="status" label="是否生效" >
              <template slot-scope="scope">
                <div v-if="scope.row.status===0">未生效</div>
                <div v-if="scope.row.status===1">已生效</div>
                <div v-if="scope.row.status===2">已失效</div>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180">
            </el-table-column>
            <el-table-column prop="info" label="备注" >
              <template slot-scope="scope">
                {{ scope.row.info ==='unsubscribe'?'已退订': scope.row.info }}
              </template>
            </el-table-column>

          </el-table>

        </div>
        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

      </el-main>
    </el-container>
  </div>
</template>

<script>
import Pagination from '../../../components/pagination'

export default {
  name: 'rabateList',
  components: {
    Pagination
  },

  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
  },

  data() {
    return {
      maxHeight: 500,
      agents: [],
      queryParams:{
        startTime:'',
        endTime:'',
        current:1,
        size:10,
        iccid:'',
        agentId:'',
        status:'',
      },
      tableData: [],
      agentJs:require('../../../api/agent'),
      profitJs: require('../../../api/profit'),
      sumMoney: 0.00
    }
  },

  methods: {
    getSumMoney(param) {
      let that=this
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }

        switch (column.property) {
          case 'profitPrice':
            column.align ='center'
            sums[index] = that.sumMoney + '元' //值取自后台
            break
          default:
            break
        }
      })
      return sums
    },
    loadAgent(){
      this.agents=[]
      this.agentJs.getSearchAgent(
              {}).then(res=>{
        res.data.data.map(item=>{
          let map={
            agentId: item.agentId,
            agentName: item.agentName
          }
          this.agents.push(map)
        })

      })
    },
    dataSearchSt(data) {
      this.queryParams.startTime=data
    },
    dataSearchEd(data) {
      this.queryParams.endTime=data
    },

    list(page) {
      let _this = this
      _this.queryParams.current=page
      _this.queryParams.size=_this.$refs.pagination.size
      _this.profitJs.getRakeBackList(_this.queryParams)
        .then(response => {
          _this.tableData = response.data.data.rows
          _this.$refs.pagination.render(page, response.data.data.total)
          //合计
          _this.profitJs.getSumMoneySys(_this.queryParams)
                  .then(res=>{
                    _this.sumMoney = res.data.data.rows
                  })
        })
    },



    exportExcel() {
      let _this = this
      _this.profitJs.importFyList(_this.queryParams)
          .then(response => {
            if(response.data.code==='0'){
              _this.$alert(response.data.data)
            }else{
              _this.$alert(response.data.msg)
            }
          })
    }
  }
}
</script>

<style lang="less" scoped>

  ::v-deep .el-table__footer-wrapper tbody td.el-table__cell, .el-table__header-wrapper tbody td.el-table__cell {
    text-align: center !important;
  }

  .mytable .el-table{
    overflow: auto;
  }


    /* 设置滚动条宽度和高度 */
  .mytable .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  .mytable .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  .mytable .el-table {
    height: 88%;
    .el-table__body-wrapper {
      height: calc(100% - 48px) !important; // 表格高度减去表头的高度
      overflow-y: auto;
    }
  }

._select {
  width: 20%;
  height: 34px;
}
.pup {
  float: right;
}
.col-md-3 {
  float: left;
}
/deep/.el-main {
  text-align: left;
  padding: 20px !important;
  overflow: hidden !important;
}
.el-ll {
  overflow: visible !important;
}
.box {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}
</style>
<style lang="less" scoped>
/deep/.el-table td,
.el-table th {
  padding: 0px;
}
</style>
<style lang="less">
.el-table td,
.el-table th {
  padding: 0px !important;
}
thead.has-gutter {
  height: 40px;
}
</style>
